import React, { useState } from 'react';
import classNames from 'classnames';
import {Button, NamedLink} from '../../components';
import css from './ReferralPage.module.css';
import {FormattedMessage} from "../../util/reactIntl";
const {
  REACT_APP_CANONICAL_ROOT_URL,
  REACT_APP_REWARD_FOR_INVITATION_TEACHER,
  REACT_APP_REWARD_FOR_INVITATION_PARENT,
  REACT_APP_REWARD_FOR_INVITATION_SCHOOL_ADMINISTRATOR,
} = process.env;
const CENTS = 100;

const ReferralPageContentEn = props => {

  const { openModal, currentUser } = props

  const [activeTab, setActiveTab] = useState("forTeachers");

  const [isCopied, setIsCopied] = useState(false);

  const path = `${REACT_APP_CANONICAL_ROOT_URL}/signup?ref=${currentUser?.id?.uuid}`;

  const copyLink = () => {
    if (typeof window === undefined) {
      return;
    }
    window.navigator.clipboard.writeText(path);

    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div className={css.content}>
      <h1 className={css.title}>Refer your colleagues</h1>

      <ul className={css.blueDescription}>
        <li>
          When any teacher you refer begins teaching, and thereby generating service fees for
          AllCourse, you will receive the first $200 in service fees generated.
        </li>
        <li>
          When any school administrator you refer begins purchasing seats in courses, you will
          receive the first $400 in service fees they generate for AllCourse.
        </li>
        <li>
          You will receive the first $100 in service fees generated by any parent you refer to
          AllCourse.
        </li>
      </ul>

      <h2 className={css.subtitle}>
        To start making referrals:
      </h2>

      <div className={css.info}>
        <div className={currentUser ? classNames(css.infoItem, css.infoItemDouble) : css.infoItem}>
          <span className={css.infoItemNumber}>01</span>
          <div>
            {currentUser && <p>Hit the “Copy” button on the right to copy your unique link</p>}

            {!currentUser && <p>Generate your unique code as a link you can copy/paste</p>}
          </div>

          {currentUser && <div className={css.copyBlock}>
            <div className={css.copyBlockContent}>

              <p className={css.copyBlockLinkValue}>
            <span>
              {path}
            </span>
              </p>
            </div>
            <Button type="button" onClick={copyLink} className={css.copyBlockButton}>
              {isCopied ? (
                <FormattedMessage id="ModalInviteFriend.copiedLink"/>
              ) : (
                <FormattedMessage id="ModalInviteFriend.copyLink"/>
              )}
            </Button>
          </div>}

        </div>



        <div className={css.infoItem}>
          <span className={css.infoItemNumber}>02</span>
          <div>
            <p>
              Compose a new email and paste your unique link into the email body
            </p>
          </div>
        </div>
        <div className={css.infoItem}>
          <span className={css.infoItemNumber}>03</span>
          <div className={css.infoItemContent}>
            <p>
              Give the email a Subject and write something in the email body explaining why you’re sending your colleague this link. Maybe something like:
            </p>

            <p className={css.infoItemContentSmall}>I thought you might be interested in teaching courses through this new marketplace for
              online for-credit courses. You can set your own schedule and rates. It’s a great way to
              earn extra income because you can teach entire classrooms (vs. tutoring just one student
              at a time).
            </p>

          </div>

        </div>
        <div className={currentUser ? classNames(css.infoItem, css.infoItemTop) : css.infoItem}>
          <span className={css.infoItemNumber}>04</span>
          <div>
            <p>
              Send the email(s). AllCourse will automatically give you credit for everyone who joins our community after clicking on the unique link in your email.
            </p>
          </div>
        </div>
      </div>


    <div className={css.moreInfo}>
      <h3 className={css.moreInfoTitle}>A few more details:</h3>

      <ul className={css.list}>
        <li>You must have a profile and be logged-in in order to generate a referral code and begin
          referring people.
        </li>
        <li>To receive bonus payments being a Teacher, you must have set up your  <NamedLink className={css.customLink} name="StripePayoutPage">
          payment details
        </NamedLink>.</li>
        <li>You can refer as many colleagues as you like.</li>
        <li>School Administrators can earn credits by inviting teachers and other admins to
          AllCourse. To avoid any possible conflict of interest, referral bonuses are not paid
          directly to the administrator but rather as credits that can be deducted against any
          future AllCourse purchases made by the admin’s school.
        </li>
        <li> If you’re wondering why parents might buy courses, it’s usually either because they’re
          home-schooling or because their child’s school doesn’t offer a particular subject that
          they really want their child to take. If you know parents like this, you could try
          referring them to AllCourse. If they buy any courses for their child, you will receive the
          first $100 in service fees they generate.
        </li>

        <li>For any referral to be valid, it must be the first time that person joined AllCourse.
        </li>
        <li> Referral bonuses are deducted from AllCourse service fees, which means you will receive
          bonuses when teachers you refer have taught courses on AllCourse and/or when admins or
          parents you refer have purchased courses on AllCourse.
        </li>
        <li>If you have any questions, contact <a className={css.customLink} href="mailto:support@allcourse.com">support@allcourse.com</a> and our team will help you
          out.
        </li>
      </ul>
    </div>



    </div>
  );
};

export default ReferralPageContentEn;
